import React from 'react';
import { usePageMeta } from '../../../hooks/usePageMeta';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import Header from '../../../components/2025/Header';
import Footer from '../../../components/2025/Footer';
import HeroTitle from '../../../components/2025/HeroTitle';
import { Chip } from '../../../components/2025/Chip';
import styles from './styles.module.scss';

const posterImage = '/images/2025/poster.jpg';

const Message2025: React.FC = () => {
  usePageMeta({
    title: 'メッセージ',
    description:
      'かまた祭2025実行委員会からのメッセージ。テーマ「ドカタノシミ」に込めた想いや、各実行委員からの挨拶をご紹介します。',
  });

  // スクロールアニメーション用のフック
  const { ref: member1Ref, isVisible: isMember1Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: member2Ref, isVisible: isMember2Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: member3Ref, isVisible: isMember3Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <div className={styles.messageContainer}>
      <Header />
      <HeroTitle title="MESSAGE" subtitle="メッセージ" />

      <div className={styles.message}>
        <div className={styles.decorations}>
          <svg className={styles.decoration1} viewBox="0 0 65 83" fill="none">
            <circle cx="15.5556" cy="25.2778" r="15.5556" fill="#F6B8DF" />
            <circle cx="41.5279" cy="49.3056" r="32.2222" stroke="#F6B8DF" strokeWidth="2.5" />
            <circle cx="41.5278" cy="6.52784" r="6.52778" fill="white" />
          </svg>

          <svg className={styles.decoration2} viewBox="0 0 81 86" fill="none">
            <rect
              x="-58"
              y="72.6886"
              width="152.577"
              height="18.2606"
              rx="9.1303"
              transform="rotate(-29.7401 -58 72.6886)"
              fill="url(#gradient1)"
            />
            <defs>
              <linearGradient id="gradient1" x1="-58" y1="81.8189" x2="94.5775" y2="81.8189">
                <stop stopColor="#0946F1" />
                <stop offset="1" stopColor="#F1ECE6" />
              </linearGradient>
            </defs>
          </svg>

          <svg className={styles.decoration3} viewBox="0 0 41 41" fill="none">
            <path
              d="M28.8162 0.995938C29.858 0.0372442 31.518 0.9718 31.2386 2.35977L28.8438 14.2587C28.7189 14.8795 29.0078 15.51 29.5596 15.8207L40.1361 21.7753C41.3698 22.4699 40.994 24.3374 39.5876 24.5006L27.531 25.8999C26.902 25.9729 26.3916 26.4426 26.2667 27.0633L23.8718 38.9623C23.5925 40.3503 21.7003 40.5699 21.1104 39.2828L16.0538 28.2487C15.7901 27.6731 15.1856 27.3328 14.5567 27.4058L2.50005 28.8052C1.09369 28.9684 0.300086 27.2366 1.34191 26.2779L10.2734 18.0591C10.7393 17.6304 10.8762 16.9504 10.6124 16.3748L5.55584 5.34065C4.96601 4.05356 6.36778 2.76365 7.60149 3.45823L18.178 9.41285C18.7298 9.72347 19.4188 9.6435 19.8847 9.21476L28.8162 0.995938Z"
              fill="#F6B8DF"
            />
          </svg>

          <svg className={styles.decoration4} viewBox="0 0 120 141" fill="none">
            <circle cx="49.6515" cy="70.5972" r="69.7208" fill="#F6B8DF" />
          </svg>
        </div>

        <div className={styles.container}>
          <div className={styles.posterThemeWrapper}>
            <section className={styles.posterSection}>
              <div className={styles.posterImage}>
                <img src={posterImage} alt="かまた祭2025ポスター" />
              </div>
            </section>

            <section className={styles.themeSection}>
              <div className={styles.chipWrapper}>
                <Chip text="THEME" variant="primary" />
              </div>
              <h1 className={styles.themeTitle}>&ldquo;ドカタノシミ&rdquo;</h1>
              <div className={styles.themeDescription}>
                <p>強烈なインパクトとエネルギーに満ちた一日へ。</p>
                <p>
                  「ドカっと」した感動や喜びを体験してほしい。記憶に残る、最高の盛り上がりを見せる文化祭になることを願ったテーマです。
                </p>
              </div>
            </section>
          </div>

          {/* Messages Section */}
          <section className={styles.messagesSection}>
            {/* Member 1 - 川田 愛音 */}
            <div
              ref={member1Ref}
              className={`${styles.memberSection} ${isMember1Visible ? styles['memberSection--visible-left'] : ''}`}
            >
              <div className={styles.memberImageWrapper}>
                <div className={styles.memberImageMask}>
                  <img src="/images/2025/川田様.png" alt="川田 愛音" />
                </div>
              </div>
              <div className={styles.memberInfo}>
                <p className={styles.memberRole}>かまた祭実行委員長</p>
                <h3 className={styles.memberName}>川田 愛音</h3>
                <p className={styles.memberMessage}>
                  こんにちは！このたびは、かまた祭に興味を持っていただき、ありがとうございます！
                  私たち実行委員は、「どうしたら来てくれる皆さんに楽しんでもらえるか」を考えながら準備を進めています。模擬店もステージも展示も、学生のパワー全開でお届けしますので、ぜひ足を運んでください！
                  会場でお会いできるのを楽しみにしています！
                </p>
              </div>
            </div>

            {/* Member 2 - 山尾 侑理 */}
            <div
              ref={member2Ref}
              className={`${styles.memberSection} ${isMember2Visible ? styles['memberSection--visible-right'] : ''}`}
            >
              <div className={styles.memberImageWrapper}>
                <div className={styles.memberImageMask}>
                  <img src="/images/2025/山尾様.png" alt="山尾 侑理" />
                </div>
              </div>
              <div className={styles.memberInfo}>
                <p className={styles.memberRole}>かまた祭実行委員長</p>
                <h3 className={styles.memberName}>山尾 侑理</h3>
                <p className={styles.memberMessage}>
                  かまた祭HPにお越しいただき、ありがとうございます！
                  模擬店のグルメ、個性あふれる展示、熱いステージパフォーマンス！学生の「やってみたい」を詰め込んだ学園祭を、私たち実行委員が全力でお届けします！
                  友だちと一緒にフラッと立ち寄って食べ歩きしたり、じっくり展示を見て回ったり、ステージで大声を出して盛り上がったり。来てくれたひとりひとりが笑顔になれる瞬間を用意してお待ちしています！私たちと青春の一ページを一緒に作りませんか？会場でお会いできるのを楽しみにしています！どなた様もどうぞお気軽にお越しください！
                </p>
              </div>
            </div>

            {/* Member 3 - 千葉 茂 */}
            <div
              ref={member3Ref}
              className={`${styles.memberSection} ${isMember3Visible ? styles['memberSection--visible-left'] : ''}`}
            >
              <div className={styles.memberImageWrapper}>
                <div className={styles.memberImageMask}>
                  <img src="/images/2025/理事長様.png" alt="千葉 茂" />
                </div>
              </div>
              <div className={styles.memberInfo}>
                <p className={styles.memberRole}>学校法人片柳学園 理事長</p>
                <h3 className={styles.memberName}>千葉 茂</h3>
                <p className={styles.memberMessage}>
                  ようこそ「かまた祭」へ！うちの学生は「好きなことだから夢中になれる」「勉強って感じじゃなくて楽しいから続けられる」そんな毎日を送っています。その熱量が作品発表やパフォーマンスに詰まっています。高校生のみなさんは未来の自分を想像しながら、大人のみなさんは青春リピートを、ここで体感してください！
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Message2025;
